import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SessionProvider } from '@/lib/session'
import { ThemeProvider } from '@/lib/theme'
import { I18nProvider } from '@/i18n'
import App from './App'
import './styles/globals.css'

import './styles/theme.css'
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
})

// PROVIDER ORDER MATTERS in exactly one place: SessionProvider must sit INSIDE
// QueryClientProvider, because the session is held in react-query's own cache
// and therefore needs a client to exist.
//
// ThemeProvider and I18nProvider are independent of both — they only touch
// <html> and localStorage — but they wrap App so that every screen, including
// the auth pages, can read the language and theme.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <I18nProvider>
          <BrowserRouter>
            <SessionProvider>
              <App />
            </SessionProvider>
          </BrowserRouter>
        </I18nProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
